import { API, API_POST } from "../../../Config";

export const handleUpdateWorkout = (payload, id) => {
  const f = new FormData();

  console.log('id', id);

  f.append("title", payload.title);
  f.append("description", payload.description);
  f.append("id", id);

  if (payload.image) {
    f.append("banner_img", payload.image);
  }

  if (payload.video) {
    f.append("video", payload.video);
  }

  return API_POST(API.EditWorkout, f);
};

